// extracted by mini-css-extract-plugin
export default {"item":"simpleReportShimmer_item__Oi9ak","item_number":"simpleReportShimmer_item_number__aANW6"};